import { MARQUEE_WORDS } from "../data/content";

export default function Marquee() {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div
      className="overflow-hidden border-y border-brass/15 bg-forest py-6"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-24 whitespace-nowrap pr-24">
        {row.map((word, i) => (
          <span key={i} className="flex items-center gap-24">
            <span className="font-serif text-lg tracking-wide text-ivory/40">
              {word}
            </span>
            <span className="h-1 w-1 rounded-full bg-brass/50" />
          </span>
        ))}
      </div>
    </div>
  );
}
